<template>
  <div
    class="absolute h-100 pr5 w-100 flex flex-column"
    style="padding-left: 25vw; max-height: 80%;"
  >
    <div
      class="f2 b mb4"
      :class="{
        'purple': brand === 'lh',
        'dark-gray': brand === 'lq'
      }"
      v-html="content.title"
      ref="title"
    />
    <div
      ref="divider"
      class="bt bw1 w3 mb4"
      :class="{
        'b--purple': brand === 'lh',
        'b--dark-gray': brand === 'lq'
      }"
    />
    <div
      class="flex justify-center items-stretch"
      style="flex-grow:1; max-height: 80%; min-height: 80%;"
    >
      <div
        v-if="content.featuredImage"
        ref="image"
        class="w-50 overflow-hidden pl4 cover bg-center image-shadow"
        :style="'background-image: url(' + content.featuredImage + ')'"
      />
      <div
        class="relative w-50 pv1 pl5 flex flex-column justify-between"
        ref="text"
      >
        <div class="pr4 slider-content overflow-auto pv4">
          <div
            class="style-list lh-copy f4"
            v-html="content.text"
          />
        </div>
        <div
          class="absolute top-0 left-0 right-0 mr5 ml2"
          style="height: 5rem; background-image: linear-gradient(to bottom, #F8F9FA, rgba(255,255,255,0))"
        />
        <div
          class="absolute bottom-0 left-0 right-0 mr5 ml2"
          style="height: 5rem; background-image: linear-gradient(to top, #F8F9FA, rgba(255,255,255,0))"
        />
      </div>
    </div>
  </div>
</template>

<script>
import gsap from 'gsap'

export default {
  name: 'TabContent',
  props: {
    brand: {
      type: String,
      default: 'lh'
    },
    content: {
      type: Object,
      default: null
    },
    button: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      arrowIcon: require('@/assets/img/icon-plus-circle.svg')
    }
  },
  methods: {
    animEnter () {
      const title = this.$refs.title
      const divider = this.$refs.divider
      const text = this.$refs.text
      const button = this.$refs.button
      const tl = gsap.timeline()
      if (title) {
        tl.from(title, {
          y: -100,
          opacity: 0,
          ease: 'back',
          delay: 0.7
        })
      }
      if (divider) {
        tl.from(divider, {
          x: 100,
          opacity: 0
        }, 1)
      }
      if (text) {
        tl.from(text, {
          opacity: 0
        }, 1.2)
      }
      if (button) {
        tl.from(button, {
          y: 100,
          opacity: 0,
          ease: 'back'
        }, 0.7)
      }
    }
  },
  mounted () {
    this.animEnter()
  }
}
</script>
<style lang="scss">
  .image-shadow {
      -webkit-box-shadow: 6px 6px 8px 0 rgb(0 0 0 / 20%);
      box-shadow: 6px 6px 8px 0 rgb(0 0 0 / 20%);
  }
  .style-list {
    ul, ol {
      padding-left: 0;
      margin-bottom: 2rem;

      li {
        padding: 1rem 0;
        // border-top: 1px solid lightgray;

        &:first-child {
          border-top: none
        }
      }
    }
    ul {
      list-style-type: none;
    }
  }
</style>
